<template>
  <div>
    <modal-provider
      name="tool-repair-registration-result-modal"
      title=""
      :width="600"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      classList=""
    >
      <div ref="modal" class="modal tool-repair-result" tabindex="0">
        <img class="tool-repair-result__img" :src="`/img/tool-repair/${this.type}.svg`" alt="">
        <div class="tool-repair-result__title" v-html="$t(`tool-repair-result__${this.type}-title`)"></div>
        <div class="tool-repair-result__subtitle" v-html="$t(`tool-repair-result__${this.type}-subtitle`)"></div>
        <Button
          class="tool-repair-result__btn"
          @click.native="hideModal"
        >
          {{ $t(`tool-repair-result__${this.type}-btn`) }}
        </Button>
      </div>
    </modal-provider>
  </div>
</template>

<script>
import Button from '@/components/inputs/Button.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ToolRepairRegistrationResultModal',
  components: { Button },
  data: function () {
    return {
      type: 'success'
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  methods: {
    hideModal () {
      this.$modal.hide('tool-repair-registration-result-modal')
    },
    beforeOpen (event) {
      this.type = event.params?.type || 'success'
    },
    beforeClose () {
      if (this.type === 'success') {
        window.location.href = this.urlLanguagePrefix + '/'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
::v-deep .modal__title
  margin-bottom: 0
.tool-repair-result
  display: flex
  flex-direction: column
  align-items: center
  &__btn
    font-size: 14px
  &__subtitle
    font-size: 16px
    color: #333
    line-height: 1.5
    text-align: center
    margin-bottom: 30px
    +mmax($tablet--hor)
      font-size: 14px
      margin-bottom: 25px
  &__title
    color: #333
    font-size: 24px
    font-weight: 500
    margin-bottom: 15px
    text-align: center
    +mmax($tablet--hor)
      font-size: 18px
      margin-bottom: 10px
  &__img
    width: 76px
    height: auto
    margin: 0 auto 20px
</style>
